module.exports = __webpack_public_path__ + "img/1572801302.4a5d8378.jpg";